import { render, staticRenderFns } from "./TemplateVariant.vue?vue&type=template&id=626d2dd0&scoped=true&"
import script from "./TemplateVariant.vue?vue&type=script&lang=js&"
export * from "./TemplateVariant.vue?vue&type=script&lang=js&"
import style0 from "./TemplateVariant.vue?vue&type=style&index=0&id=626d2dd0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "626d2dd0",
  null
  
)

export default component.exports